var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.091 17.9819L8.80918 18.8092C7.61827 19.5455 5.96373 18.7183 5.96373 17.2455V12.3819C5.96373 11.7365 5.60009 10.9092 5.22736 10.4546L1.73645 6.78191M1.73645 6.78191C1.27282 6.31827 0.90918 5.50009 0.90918 4.94554V2.83645C0.90918 1.73645 1.73645 0.90918 2.74554 0.90918H6.36373M1.73645 6.78191C5.671 5.66191 6.46069 2.40009 6.36373 0.90918M15.791 6.87282C16.2455 6.41827 16.7092 5.50009 16.7092 4.76372V2.74554C16.7092 1.73645 15.8819 0.90918 14.8728 0.90918H6.36373",
    stroke: "#64B431",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4273 9.88909L10.2091 13.1073C10.0819 13.2345 9.96367 13.4709 9.9364 13.6436L9.76367 14.8709C9.70004 15.3164 10.0091 15.6255 10.4546 15.5618L11.6819 15.3891C11.8546 15.3618 12.1 15.2436 12.2182 15.1164L15.4364 11.8982C15.9909 11.3436 16.2546 10.6982 15.4364 9.88C14.6273 9.07091 13.9819 9.33455 13.4273 9.88909Z",
    stroke: "#64B431",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9727 10.3438C13.2454 11.3256 14.009 12.0892 14.9908 12.3619",
    stroke: "#64B431",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterI);
export default __webpack_public_path__ + "static/media/FilterI.5493225a7547c304e8767dd4bd46ae5e.svg";
export { ForwardRef as ReactComponent };